import { Badge } from '@shared/components';
import type { BadgeProps } from '@shared/components/ui/badge/Badge';
import type { AgreementStatus } from '../types/agreements.types';
import { isKnownAgreementStatus, statusLabel } from '../utils/agreementStatus';

// Statuses that share a variant are told apart by their distinct labels.
const STATUS_VARIANT: Record<AgreementStatus, BadgeProps['variant']> = {
    draft: 'outline',
    active: 'success',
    on_hold: 'warning',
    suspended: 'warning',
    pending_cancellation: 'warning',
    cancelled: 'error',
    cancellation_reversed: 'secondary',
    pending_transfer: 'warning',
    transferred: 'info',
    transfer_reversed: 'secondary',
    pending_claim: 'error',
    expired: 'info',
    completed: 'info',
    renewed: 'info',
    dead: 'outline',
};

interface Props {
    status: AgreementStatus | string;
}

/** An UNRECOGNISED status falls back to the `outline` variant and renders the
 *  raw value verbatim — this badge must never be the thing that breaks when
 *  the backend's status enum grows (F9). */
export function AgreementStatusBadge({ status }: Props) {
    const variant = isKnownAgreementStatus(status) ? STATUS_VARIANT[status] : 'outline';
    return <Badge variant={variant}>{statusLabel(status)}</Badge>;
}
